import { z } from 'zod'

import type { ZodInfer } from './utility-types.ts'

/**
 * Validates that a string can be converted to a valid number
 */
const isValidNumberString = (value: string): boolean => {
  const convertedNumber = Number(value)

  if (Number.isNaN(convertedNumber) || !Number.isFinite(convertedNumber)) {
    return false
  }

  return true
}

/**
 * A string that can be converted to a valid number
 */
export const NumberStringSchema = z
  .string()
  .min(1)
  .refine(isValidNumberString, {
    error: 'Value must be a valid number string',
  })

export type NumberString = ZodInfer<typeof NumberStringSchema>
